import { IStatusLabels } from '@shared/ui-components/au-cmms-status-label/interfaces/status-labels.interface';

/**
 * Object keys inside should be exact same lowercased values that
 * we received from BE
 */

export const STATUS_LABELS: IStatusLabels = {
	NEW: {
		color: 'red',
		name: 'new',
	},
	PLANNED: {
		color: 'red',
		name: 'planned',
	},
	ASSIGNED: {
		color: 'purple',
		name: 'assigned',
	},
	IN_PROGRESS: {
		color: 'yellow',
		name: 'in_progress',
	},
	SUBMITTED: {
		color: 'purple',
		name: 'submitted',
	},
	TODO: {
		color: 'purple',
		name: 'todo',
	},
	COMPLETED: {
		color: 'green',
		name: 'completed',
	},
	APPROVED: {
		color: 'purple',
		name: 'approved',
	},
	AWAITING_APPROVAL: {
		color: 'red',
		name: 'awaiting_approval',
	},
	CANCELLED: {
		color: 'gray',
		name: 'cancelled',
	},
	IN_REVIEW: {
		color: 'red',
		name: 'in_review',
	},
	REJECTED: {
		color: 'gray',
		name: 'rejected',
	},
	WO_CREATED: {
		color: 'purple',
		name: 'wo_created',
	},
	OPEN: {
		color: 'purple',
		name: 'open',
	},
	CLOSED: {
		color: 'green',
		name: 'closed',
	},
	WAITING: {
		color: 'gray',
		name: 'waiting',
	},
};
